module.exports = __webpack_public_path__ + "al.ec95fee3d8804daae3c0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/al.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/al.svg
// module chunks = styles